<mat-button-toggle-group [hideSingleSelectionIndicator]="true" #group="matButtonToggleGroup" (change)="onUomChange(group.value)">
    <mat-button-toggle value="Bbl" [checked]="uom === 'Bbl'">BBL</mat-button-toggle>
    <mat-button-toggle value="Gll" [checked]="uom === 'Gll'">GLL</mat-button-toggle>
    <mat-button-toggle value="L" [checked]="uom === 'L'">L</mat-button-toggle>
</mat-button-toggle-group>